
import React from 'react';

const WhoWeWorkWithSection = () => {
  const clients = [
    { icon: 'ri-shield-star-line', name: 'Sports Clubs' },
    { icon: 'ri-government-line', name: 'Federations' },
    { icon: 'ri-school-line', name: 'Academies' },
    { icon: 'ri-calendar-event-line', name: 'Event Organisers' },
    { icon: 'ri-briefcase-line', name: 'Athlete Management' },
    { icon: 'ri-building-line', name: 'Sport Businesses' },
    { icon: 'ri-run-line', name: 'Athletes' },
    { icon: 'ri-user-settings-line', name: 'Coaches' },
    { icon: 'ri-user-star-line', name: 'Executives' },
  ];

  // Simple guard – ensures an icon class is always a string
  const getIconClass = (icon) => (typeof icon === 'string' ? icon : '');

  return (
    <section className="bg-[#0A1628] py-24">
      <div className="max-w-[1200px] mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-white text-center mb-16">
          Trusted by sports organisations
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {clients.map((client, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 hover:bg-white/15 hover:scale-105 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                {/* Fixed the template‑literal syntax error */}
                <i
                  className={`${getIconClass(client.icon)} text-5xl text-[#0066FF]`}
                ></i>
              </div>
              <h3 className="text-white text-lg font-semibold">{client.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeWorkWithSection;
